import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get, del } from "@utils/axios_api";
import { downloadExcel } from "@utils/downloadExcel";
/**
 * 목록조회 + 삭제 로직을 담당하는 훅
 */
const fetchInstructorList = async (params) => {
    const response = await get("/admin/ins/instructorList", { params });
    return response;
};
export function useInstructor(queryParam) {
  const [selectedItems, setSelectedItems] = useState([]);


  const { data, refetch } = useQuery({
    queryKey: ["instructorList", queryParam],
    queryFn: () => fetchInstructorList(queryParam),
    keepPreviousData: true,
  });

  // const handleSelectAll = (checked) => {
  //   if (!data || !data.resultList) return;
  //   if (checked) {
  //     const allIds = data.resultList.map((item) => item.instructorId);
  //     setSelectedItems(allIds);
  //   } else {
  //     setSelectedItems([]);
  //   }
  // };


  // const handleSelectItem = (id) => {
  //   if (selectedItems.includes(id)) {
  //     setSelectedItems(selectedItems.filter((x) => x !== id));
  //   } else {
  //     setSelectedItems([...selectedItems, id]);
  //   }
  // };


    /* ---------- 체크박스 ---------- */
    const handleSelectAll = (checked) => {
      if (!data || !data.resultList) return;
      checked
        ? setSelectedItems(data.resultList.map((v) => v.instructorId))
        : setSelectedItems([]);
    };
  
    const handleSelectItem = (id) => {
      setSelectedItems((prev) =>
        prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
      );
    };





  const instructorDelete = async () => {
    if (!selectedItems.length) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }

    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");
    if (!isConfirmed) return;

    try {
      const response = await del("/admin/ins/instructorDelete", {
        data: {
          idlist: selectedItems,
        },
      });
      alert(response?.message);
      refetch(); 
      setSelectedItems([]); 
    } catch (err) {
      console.error(err);
      alert("삭제 실패");
    }
  };

    /* ---------- 엑셀 ---------- */
    const handleExcelDownload = (e) => {
      e.preventDefault();
      downloadExcel({
        url: "/admin/ins/instructorListExcelDown",
        params: queryParam,
        filePrefix: "강사 목록",
      });
    }


  const isAllChecked = !!(data?.resultList?.length && selectedItems.length === data?.resultList?.length);

  return { data, refetch, selectedItems, isAllChecked,  handleSelectAll, handleSelectItem, instructorDelete, handleExcelDownload };
}
